// extracted by mini-css-extract-plugin
export default {"drawer":"iT","drawerheader":"jT","retake_quiz_bottom_bar":"kT","extra_drawer":"lT","not_answered_questions":"mT","question_ui":"nT","accordion_details":"oT","retake_quiz":"pT","accordions":"qT","accordion_root":"rT","accordion_summary_text":"sT","animation":"tT","show_animation":"uT","overflow_hidden":"vT"};
    if(module.hot) {
      // 1711394579544
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  